import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const CreateEncounterSummaryBlockConfigSchema = z.object({
  payload: z.string().min(1, { message: 'Payload is required' }),
  gsPath: z.string().min(1, { message: 'Google Storage path is required' }),
});
export type CreateEncounterSummaryBlockConfig = z.infer<
  typeof CreateEncounterSummaryBlockConfigSchema
>;

export const CreateEncounterSummaryBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.CreateEncounterSummary),
  returnType: returnTypeSchema(ProducedType.EncounterSummary),
  config: CreateEncounterSummaryBlockConfigSchema,
});
export type CreateEncounterSummaryBlock = z.infer<typeof CreateEncounterSummaryBlockSchema>;
